export default __webpack_public_path__ + "513a92f2df6935ca78e822c53ae3c358.png";